import { toRaw } from "vue"
import qs from "qs"

export const useApiRequest = async (endpoint, options = { loadingIndicator: null }) => {
  const config = useRuntimeConfig()
  const { data: auth } = useAuth()

  const accessToken = auth?.value?.token

  const query = options.params ? '?' + qs.stringify(toRaw(options.params), { arrayFormat: "brackets" }) : ''
  const url = `${config.public.apiBaseUrl}/${endpoint}${query}`
  try {
    options?.loadingIndicator?.start()

    const data = await $fetch(url, {
      method: options.method || 'GET',
      headers: {
        ...options.headers,
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
      },
      body: options.body,
      responseType: options?.responseType,
    })

    return {
      data: ref(data),
      error: ref(null),
    }
  } catch (error) {
    return { data: ref(null), error: ref(error) }
  } finally {
    options?.loadingIndicator?.start()
  }
}
